import { useState, useEffect, useCallback } from "react";
import { COMPANY_URL, LOCAL_URL } from "../constants/apiUrls";
import { useNavigate } from "react-router-dom";

function useCombinedCompanyData(
  searchTerm,
  code,
  trevexToken,
  worldBoxToken,
  noPopup = false,
  isPrompt = false,
  page
) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");
  const [fetchToggle, setFetchToggle] = useState(false); // Used to trigger refetch

  // Refetch function
  const refetch = useCallback(() => {
    setFetchToggle((prev) => !prev);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!searchTerm || searchTerm.trim().length < 3) {
        setError("Search term must have at least 3 characters");
        setData([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      setMessage("");

      try {
        const localServerUrl = isPrompt
          ? `/api/api/gpt_prompts/search/?search=${searchTerm}&page=${page}`
          : `/api/company/search_new/?search=${searchTerm}&country_code=${code}`;
        
        const headers = {
            ...(trevexToken && { Authorization: `Bearer ${trevexToken}` }),
        };
        const response = await fetch(localServerUrl, {
          headers,
        })
        
        const result = await response.json();
        
        if (response.ok) {
          if (result.error) {
            setMessage("Error occurred while fetching data.");
          } else if (result.warning) {
            setMessage(
              "Too many results found. Please refine your search for better results."
            );
          } else {
            setData(isPrompt ? result : result.data || []);
          }
        } else {
          setError(result.detail || result.error || "An error occurred while fetching data.");
        }
      } catch (fetchError) {
        setError("Failed to fetch data. Please try again later.");
        console.error("Fetch Error:", fetchError);
      }

      setIsLoading(false);
    };

    fetchData();
  }, [searchTerm, code, isPrompt, page, trevexToken, fetchToggle]);

  return { data, isLoading, error, message, refetch };
}

export default useCombinedCompanyData;

